<template>
    <v-layout :fill-height="!loaded" column>
        <visa-booking-page-layout
            v-if="loaded && offer"
            :search-request="searchRequest"
            :offer="offer"
            :search-request-country-id="searchRequestCountryId"
        >
            <template v-slot:breadcrumbs>
                <expired-offers-snackbar :is-offers-expired="isOffersExpired" @refresh="refreshExpiredOffers" />
                <visa-breadcrumbs :search-request="searchRequest" />
            </template>
            <template v-slot:tourists="{tourists, index, personSelected, bookingKey, isSavingWithoutDetails, formRefs}">
                <tourist-form
                    :ref="el => formRefs.push(el)"
                    :key="index"
                    v-model="tourists[index]"
                    :index="index"
                    label="tourist"
                    :disabled="!!bookingKey"
                    :corporate-policy-violation="offer ? offer.corporatePolicyViolation : undefined"
                    :hide-index="tourists.length === 1"
                    :selected-tourists="tourists"
                    :start-date="startDate"
                    :data-cy="`tourist-${index}`"
                    :disable-required-rule="isSavingWithoutDetails"
                    @person-selected="personSelected($event)"
                />
            </template>
            <template v-slot:forms="{bookingKey, formRefs}">
                <booking-comments-form
                    :ref="el => formRefs.push(el)"
                    :disabled="!!bookingKey"
                    :product-store="productStore"
                    :outlined="false"
                />
            </template>
            <template v-slot:sidebar="{bookingKey, prepareBookResponse}">
                <visa-order-summary
                    :search-request="searchRequest"
                    :product="product"
                    :offer="offer"
                    :prepare-book-response="prepareBookResponse"
                    :prebooked="!!bookingKey"
                >
                    <template v-slot:summary>
                        <v-card flat rounded="0" class="mb-2 pa-0">
                            <v-card-text class="pa-0">
                                <search-summary-content
                                    :search-request="searchRequest"
                                    tourists-label="tourist"
                                    show-dates
                                    :show-days-count="false"
                                    show-tourists
                                />
                            </v-card-text>
                        </v-card>
                    </template>
                </visa-order-summary>
                <!--                <insurance-info-modal />-->
            </template>
        </visa-booking-page-layout>
        <conditions-modal>
            <template v-slot:info>
                <visa-conditions-modal-info />
            </template>
        </conditions-modal>
    </v-layout>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import VisaBookingPageLayout from '@/components/visa/booking/VisaBookingPageLayout.vue'
    import ExpiredOffersSnackbar from '@/components/search/ExpiredOffersSnackbar.vue'
    import {bookingFields} from '@/utils/visa/visa-blank-states'
    import {UTCToDate} from '@/utils/helpers'
    import BookingCommentsForm from '~src/components/booking/forms/bookingCommentsForm.src'
    import VisaOrderSummary from '@/components/visa/booking/VisaOrderSummary.vue'
    import ConditionsModal from '@/components/modals/ConditionsModal.vue'
    import TouristForm from '~src/components/booking/forms/touristForm.src'
    import SearchSummaryContent from '@/components/parts/SearchSummaryContent.vue'
    import {VisaStoreMixin} from '@/mixins/VisaStoreMixin.vue'
    import VisaBreadcrumbs from '~/components/visa/VisaBreadcrumbs.vue'
    import VisaConditionsModalInfo from '~/components/visa/snippets/VisaConditionsModalInfo.vue'

    @Component({
        components: {
            VisaConditionsModalInfo,
            VisaBreadcrumbs,
            // InsuranceInfoModal,
            VisaBookingPageLayout,
            ExpiredOffersSnackbar,
            BookingCommentsForm,
            VisaOrderSummary,
            ConditionsModal,
            TouristForm,
            SearchSummaryContent,
        },
    })
    export class VisaBookingPage extends mixins(VisaStoreMixin) {
        loaded = false

        async mounted() {
            await this.$store.restored
            await Promise.all([
                await useVisaRuntimeData({
                    query: this.searchRequest,
                }),
                // runtimeStore.loadTouristBookingFields({offerKey: this.$route.query.offerKey}),
            ])
            runtimeStore.SET_CUSTOM_TOURIST_BOOKING_FIELDS(bookingFields()) // TODO: temporary solution

            this.loaded = true
        }

        isOffersExpired() {
            return (
                this.$dateFns.isAfter(new Date(), UTCToDate(this.$dateFns.parseISO(this.offer.expirationTime))) &&
                !runtimeStore.bookingActive &&
                !visaStore.prepareBookResponse.bookingKey
            )
        }

        refreshExpiredOffers() {
            this.$router.push(visaRuntimeStore.searchPageLink(this.searchRequest))
        }

        get searchRequestCountryId() {
            return visaRuntimeStore.location.id
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }

        get basketItem() {
            return visaStore.basketItem(this.$route.query.offerKey)
        }

        get product() {
            return this.basketItem.product
        }

        get offer() {
            return this.product.offers.find(offer => offer.offerKey === this.$route.query.offerKey)
        }

        get startDate() {
            return this.searchRequest.startDate
        }
    }

    export default VisaBookingPage
</script>
